import { render, staticRenderFns } from "./PolizasFinanzasResponse.vue?vue&type=template&id=6020d6f0&scoped=true&"
import script from "./PolizasFinanzasResponse.vue?vue&type=script&lang=js&"
export * from "./PolizasFinanzasResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6020d6f0",
  null
  
)

export default component.exports